<template>
  <div class="has-text-centered is-size-7 mt-1">
    <a @click="$emit('clicked')">{{ label }}</a>
  </div>
</template>

<script>
export default {
  name: "ResetAllFiltersButton",
  props: {
    label: {
      type: String,
      default: 'Reset Filters',
    }
  }
}
</script>

<style scoped>
</style>